import { environment } from '@environments/environment';

export const USERS_API_PREFIX = '/api/Users';

export const USERS_API = {
  LOGIN: `${USERS_API_PREFIX}/login`,
  REGISTER: `${USERS_API_PREFIX}/register`,
  REFRESH: `${USERS_API_PREFIX}/refresh`,
  FORGOT_PASSWORD: `${USERS_API_PREFIX}/forgot-password`,
  SET_PASSWORD: `${USERS_API_PREFIX}/set-password`,
  RESET_PASSWORD: `${USERS_API_PREFIX}/reset-password`,
  CHANGE_PASSWORD: `${USERS_API_PREFIX}/me/change-password`,
  MANAGE_INFO_V2: `${USERS_API_PREFIX}/manage/info-v2`,
  USERS_LIST: USERS_API_PREFIX,
  ME: `${USERS_API_PREFIX}/me`,
  USER_BY_ID: (id: string) => `${USERS_API_PREFIX}/${encodeURIComponent(id)}`,
  IMPERSONATE: (id: string) => `${USERS_API_PREFIX}/${encodeURIComponent(id)}/impersonate`,
  STOP_IMPERSONATION: `${USERS_API_PREFIX}/stop-impersonation`,
  CONCERNED_ENTITIES: '/api/concerned-entities',
  CONCERNED_ENTITY_LOGO: (id: string) => `/api/concerned-entities/${encodeURIComponent(id)}/logo`,
} as const;

export function usersApiUrl(path: string): string {
  return `${environment.crApiUrl}${path}`;
}

export function isUsersRefreshRequest(url: string): boolean {
  return url.includes(USERS_API.REFRESH);
}

export function isUsersLoginRequest(url: string): boolean {
  return url.includes(USERS_API.LOGIN);
}
